import { createSlice } from "@reduxjs/toolkit";

/******************** SLICE **************************/

const _initialState = {
  loadingTypologies: false,
  identTypologies: [],
};

const enumsSlice = createSlice({
  name: "enumsSlice", // REDUX Storage name
  initialState: _initialState,
  reducers: {
    setIdentTypologies: (state, action) => {
      state.identTypologies = action.payload;
    },
  },
});

export const { name, actions, reducer } = enumsSlice;
